import {Container, Point} from 'pixi.js';

export type PointerEventHandler = (event: PointerEvent) => void;

export function getRoot(container: Container): Container {
    while (container.parent) {
        container = container.parent;
    }

    return container;
}

export type PointerEvent = {
    target: Container;
    data: {
        global: Point;
    };
};